import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../contexts/auth';

export default function ResendOtp({ callSendOTP }) {
  const [timeLeft, setTimeLeft] = useState(30);
  const [authState] = useAuth();

  useEffect(() => {
    setTimeLeft(30);
  }, [authState?.resendOtp]);

  useEffect(() => {
    let intervalId;
    if (timeLeft > 0) {
      intervalId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [timeLeft]);
  return (
    <>
      <button
        size="large"
        type="submit"
        style={{
          border: 'none',
          color: timeLeft > 0 ? 'rgba(0, 0, 0, 0.26)' : '#1276d7',
          background: 'transparent',
          alignItems: 'center',
          marginTop: '10px',
          marginBottom: '10px',
          float: 'right',
        }}
        disabled={timeLeft > 0}
        onClick={(e) => {
          e.preventDefault();
          callSendOTP();
          setTimeLeft(30);
        }}
      >
        Resend OTP {timeLeft > 0 && `in ${timeLeft}`}
      </button>
    </>
  );
}
ResendOtp.propTypes = {
  callSendOTP: PropTypes.func,
};
